// extracted by mini-css-extract-plugin
export default {"tosTitle":"TosPage_tosTitle__rXIEZ","tosContent":"TosPage_tosContent__zcM2Q","tosTextContent":"TosPage_tosTextContent__ieufo","tosParagraph":"TosPage_tosParagraph__9l5Gq"};